module.exports = __webpack_public_path__ + "src/assets/animations/foxglove.txt";


//////////////////
// WEBPACK FOOTER
// ./src/assets/animations/foxglove.txt
// module id = ./src/assets/animations/foxglove.txt
// module chunks = 0